// src/shared/store/apiSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { makeApiRequest } from '../api';

export const fetchAllFaceBots = createAsyncThunk(
  'allFaceBots/fetchAllFacebots',
  async(_, { rejectWithValue }) => {
    try {
      const response = await makeApiRequest('GET', 'facebots');
      return response;
    } catch (error) {
      return rejectWithValue('Error fetching dashboard config.');
    }
  }
);

// Slice
const fbSlice = createSlice({
  name: 'allFaceBots',
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {
    clearAllKb: (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllFaceBots.pending, (state) => {
        state.loading = true;
        state.data = null;
        state.error = null;
      })
      .addCase(fetchAllFaceBots.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAllFaceBots.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearAllKb } = fbSlice.actions;

export default fbSlice.reducer;
